import axios from 'axios';

import { serializeParams } from './serialize-params';

// Imported first by src/index.js: every request of the default axios instance keeps the params format of axios 0.21
axios.defaults.paramsSerializer = serializeParams;
